import { useEffect, useState } from 'react'
import { supabase } from '../../lib/supabase'
import AdminLayout from '../../components/AdminLayout'

export default function FotosFijasML() {
  const [placas, setPlacas] = useState([])
  const [loading, setLoading] = useState(true)
  const [uploading, setUploading] = useState(null) // slug en curso
  const [msg, setMsg] = useState(null)
  const [previewUrls, setPreviewUrls] = useState({})

  async function cargar() {
    setLoading(true)
    const { data } = await supabase
      .from('ml_fotos_fijas')
      .select('*')
      .order('orden')
    setPlacas(data || [])
    if (data) {
      const urls = {}
      for (const p of data) {
        const { data: signed } = await supabase.storage
          .from(p.storage_bucket)
          .createSignedUrl(p.storage_path, 3600)
        if (signed?.signedUrl) urls[p.slug] = signed.signedUrl
      }
      setPreviewUrls(urls)
    }
    setLoading(false)
  }

  useEffect(() => { cargar() }, [])

  async function subirJpg(placa, file) {
    if (!file) return
    if (file.size > 5 * 1024 * 1024) {
      setMsg({ ok: false, text: 'Máximo 5 MB.' })
      return
    }
    setUploading(placa.slug)
    setMsg(null)
    try {
      const path = `fijas/${placa.slug}-v${placa.version || 1}.jpg`
      await supabase.storage.from(placa.storage_bucket).remove([path]).catch(() => {})
      const { error: upErr } = await supabase.storage
        .from(placa.storage_bucket)
        .upload(path, file, { contentType: file.type || 'image/jpeg', upsert: true })
      if (upErr) throw upErr

      await supabase.from('ml_fotos_fijas').update({
        storage_path: path,
        ultimo_render_at: new Date().toISOString(),
      }).eq('id', placa.id)

      setMsg({ ok: true, text: `✓ ${placa.titulo} actualizada.` })
      await cargar()
    } catch (e) {
      setMsg({ ok: false, text: `Error: ${e?.message || String(e)}` })
    } finally {
      setUploading(null)
    }
  }

  return (
    <AdminLayout title="Fotos fijas — Mercado Libre">
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '24px 20px' }}>

        <div style={{ marginBottom: 24 }}>
          <h1 style={{ fontSize: 24, fontWeight: 800, margin: 0, letterSpacing: '-0.02em' }}>Fotos fijas Limpack</h1>
          <p style={{ fontSize: 14, color: '#64748B', margin: '6px 0 0' }}>
            Placas institucionales que se anexan automáticamente al final de cada publicación ML.
          </p>
        </div>

        <div style={{
          background: 'rgba(0,168,181,0.06)',
          border: '1px solid rgba(0,168,181,0.18)',
          borderRadius: 10,
          padding: '14px 18px',
          marginBottom: 24,
          fontSize: 13,
          color: '#1A3461',
          lineHeight: 1.6,
        }}>
          <strong>Cómo actualizar una placa:</strong> abrí el preview HTML <code style={{ background: 'rgba(0,168,181,0.1)', color: '#00A8B5', padding: '1px 6px', borderRadius: 3, fontSize: 12 }}>docs-proyecto/01-marketing/placas-ml-preview.html</code>, apretás "↓ Descargar JPG" en la placa que querés, y subís el archivo descargado acá abajo. Listo — la próxima publicación ML ya la usa.
        </div>

        {msg && (
          <div style={{
            background: msg.ok ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)',
            border: `1px solid ${msg.ok ? 'rgba(16,185,129,0.3)' : 'rgba(239,68,68,0.3)'}`,
            borderRadius: 8,
            padding: '12px 16px',
            marginBottom: 20,
            fontSize: 13,
            color: msg.ok ? '#065F46' : '#991B1B',
          }}>{msg.text}</div>
        )}

        {loading ? (
          <p style={{ color: '#64748B' }}>Cargando…</p>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(420px, 1fr))', gap: 20 }}>
            {placas.map(p => (
              <div key={p.id} style={{
                background: '#fff',
                border: '1px solid rgba(26,52,97,0.1)',
                borderRadius: 12,
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
              }}>
                <div style={{
                  aspectRatio: '1',
                  background: '#0A1424',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                }}>
                  {previewUrls[p.slug] ? (
                    <img src={previewUrls[p.slug]} alt={p.titulo} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                  ) : (
                    <div style={{ color: '#7888A3', fontSize: 13, textAlign: 'center', padding: 20, lineHeight: 1.6 }}>
                      Sin imagen todavía.<br/>Subí el JPG abajo.
                    </div>
                  )}
                  {!p.activa && (
                    <div style={{
                      position: 'absolute', top: 8, right: 8,
                      background: 'rgba(0,0,0,0.6)', color: '#fff',
                      fontSize: 10, padding: '4px 8px', borderRadius: 4,
                      letterSpacing: '0.1em', textTransform: 'uppercase',
                    }}>Inactiva</div>
                  )}
                </div>

                <div style={{ padding: 16 }}>
                  <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 12, marginBottom: 6 }}>
                    <h3 style={{ fontSize: 16, fontWeight: 700, margin: 0, color: '#1A3461' }}>{p.titulo}</h3>
                    <span style={{ fontSize: 11, color: '#7888A3', letterSpacing: '0.05em' }}>orden {p.orden}</span>
                  </div>
                  <p style={{ fontSize: 12.5, color: '#64748B', margin: '0 0 14px', lineHeight: 1.5 }}>{p.descripcion}</p>

                  {p.ultimo_render_at && (
                    <div style={{ fontSize: 11, color: '#7888A3', marginBottom: 12 }}>
                      Última actualización: {new Date(p.ultimo_render_at).toLocaleString('es-UY')}
                    </div>
                  )}

                  <label style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 8,
                    background: '#1A3461',
                    color: '#fff',
                    padding: '9px 16px',
                    borderRadius: 8,
                    fontSize: 13,
                    fontWeight: 600,
                    cursor: uploading ? 'wait' : 'pointer',
                    opacity: uploading ? 0.6 : 1,
                  }}>
                    {uploading === p.slug ? 'Subiendo…' : `↑ Subir JPG (1200×1200)`}
                    <input
                      type="file"
                      accept="image/jpeg,image/png"
                      style={{ display: 'none' }}
                      onChange={e => subirJpg(p, e.target.files[0])}
                      disabled={uploading !== null}
                    />
                  </label>
                </div>
              </div>
            ))}
          </div>
        )}

      </div>
    </AdminLayout>
  )
}
